import "../tablestyle.scss";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
  GridNoRecords
} from "@progress/kendo-react-grid";
import { DropDown } from "../myDropDown";
import ButtonDefault from "../../button";
import { useEffect, useState } from "react";
import AddProject from "../../../modal/addProject";
import { useNavigate } from "react-router-dom";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { checkAvailability, checkPositionStatus, getMilliSecUTC } from "../../../utils/EllowUtils";
import * as CONSTANTS from '../../../utils/CONSTANTS'
import { contractMetadata, getAllocatedto, getProjects, updateAllocationResource, updateCandidateStatus, updatePositionStatus, updateProject ,  getProjectDetails, saveFulltimejobDetails} from "../services";
import FulltimeDetails from "../../../modal/fullTimeDetails";
import { SortDescriptor } from "@progress/kendo-data-query";
import { orderBy } from "@progress/kendo-react-data-tools";
import NotificationAlert from "../../notification";
import { Icon } from '@iconify/react';
import SubmitResources from '../../../pages/submitResources';


const userLoginId = localStorage.getItem('loginId')

const CRAppliedResourcesTable = (props: any) => {
  
  let jobId = props.jobId
  let customerId = props.customerId
  const { v4: uuidv4 } = require("uuid")
  const [projectList, setProjectList] = useState<any>()
  const [allocatedTo, setAllocatedTo] = useState<any>();
  const [contractLoginId, setContractLoginId] = useState<any>('')
  const [jobDetails, setJobDeatils] = useState<any>({})
  const [contractDetails, setContractDetails] = useState<any>(false);
  const [fulltimeDetails, setFulltimeDetails] = useState<any>(false);
  const [contractDefaultData, setContractDefaultData] = useState<any>()
  const [candidateEmail, setCandidateEmail] = useState<any>()
  const [submitResources, setSubmitResources] = useState<boolean>(false)
  const [submitResourcesData, setSubmitResourcesData] = useState<boolean>(false)
  const [projectData, setProjectData] = useState<any>()
  const [position_Status, setPosition_Status] = useState<any>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [allocatedToId, setAllocatedToId] = useState<any>()
  const [icon, setIcon] = useState<boolean>(false)

  const initialSort: Array<SortDescriptor> = [
    { field: "name", dir: "asc" },
  ];

  const [sort, setSort] = useState(initialSort);

  useEffect(() => {

    allocatedToList()
    getProjectList(customerId)
    setJobDeatils(props.jobMetadata)
    setAllocatedToId(props.allocatedToId)
    

  }, [])

  const getProjectList = (customerId: any) => {
    getProjects(customerId).then((response) => {
      if (response && response.status === 1) {
        setProjectList(response.data)
      }
    })
  }

  const allocatedToList = () => {
    getAllocatedto().then((response) => {
      if (response && response.status === 1) {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        )
      }
    })
  }

  const skillsCell = (props: GridCellProps) => {

    let length = props.dataItem.skills && props.dataItem.skills.length;

    return (
      <td >
        <div className="skillsWrap">
          {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number) => {
            return ((item) + (key < length - 1 ? ' , ' : ''))
          })}
        </div>
      </td>
    )
  }

  const rowClick = (e: any) => {
    props.rowClick(e)
  }

  const experienceCell = (props: GridCellProps) => {
    return <td>{props.dataItem.experience + " Years"}</td>;
  }

  const ellowrateCell = (props: GridCellProps) => {
    return <td>{props.dataItem.positionEllowRate ? props.dataItem.positionEllowRate + " " + props.dataItem.positionCurrencyType + " / " + props.dataItem.positionBillingType : 'Not Mentioned'}</td>;
  }

  const resourcecostCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.resourceRate !== null ? props.dataItem.resourceRate + " " + props.dataItem.currencyType + " / " + props.dataItem.billingType : 'Not Mentioned'}
      </td>
    )
  }

  const viewButton = (Props: GridCellProps) => { 
    return (
      <td>
        {Props.dataItem.positionStatus === "Resource Accepted Offer" && <button type="button" className="applyButton" onClick={(e: any) => { setContractLoginId(Props.dataItem.loginId); setContractDetails(true); setContractDefaultData(Props.dataItem.contractMetadata); setCandidateEmail(Props.dataItem.candidateEmail); setProjectData(Props.dataItem.projectDetails); setPosition_Status(Props.dataItem.positionStatus) }}>
          Contract Details</button>}
      </td>
    )
  }

  const availablityCell = (props: GridCellProps) => {
    let data = {
      availability : props.dataItem.availability
    }
    return (
      <td>
        {checkAvailability(data)}
      </td>
    )
  }

  const updatePositionStatusFunction = (value: any) => {
    
    updatePositionStatus(value).then((response) => {
      if (response.status === 1) {
        getTableValues()
      }
    })
  }

  const submmitFUlltimeDetails = (data: any) => {
    data.contractId = uuidv4()
    let value = {
      "candidateId": contractLoginId,
      "userLoginId": userLoginId,
      "jobId": jobId,
      "submittedBy":  "RECRUITER",
      "fullTimeMetadata": data,
    }
    saveFulltimejobDetails(value).then((resp) => {
      if (resp && resp.status === 1) {
        setFulltimeDetails(false)
        let newvalue = {
          "candidateId": contractLoginId,
          "userLoginId": userLoginId,
          "jobId": jobId,
          "positionStatus": 5,
          "jobType": jobDetails.jobType
        }
        updatePositionStatusFunction(newvalue)
      }
      props.getPositionDetails()
    })
    
  }

  const positionStatusDropdown = (props: GridCellProps, getTableValues: any) => {
    
    const { dataItem } = props;
    const field = props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field]
    
    const handleChange = (e: DropDownListChangeEvent) => {
  
      checkFunction(props.dataItem)

      if (e.target.value.id === 1) {
        if (basic.length > 0) {
          displayNotification('Please verify the candidate and the change the ellow status to verified before submission')
        }
        if (full.length > 0) {
          displayNotification('Please complete full profile and verify before applying ')
        }
        if (verified.length > 0 && basic.length === 0 && full.length === 0) {
          setSubmitResourcesData(props.dataItem)
          setSubmitResources(true)
        }
      }
      if (e.target.value.id === 10) {
        let value = {
          "candidateId": props.dataItem.loginId,
          "userLoginId": userLoginId,
          "jobId": jobId,
          "positionStatus": e.target.value.id,
          "jobType": jobDetails.jobType
        }
        updatePositionStatusFunction(value)
      }
    }

    let verified: any = []
    let basic: any = []
    let full: any = []
    const checkFunction = (data: any) => {
      if (data.candidateStatus  === 'F3 - Verified') {
         verified.push(data)
      }
      if (data.candidateStatus  === 'F1 - Basic profile submitted') {
        basic.push(data)
      }
      if (data.candidateStatus  === 'F2 - Full profile submitted') {
        full.push(data)
      }
    }
  
    const displayNotification = (message: string) => {
      setMessage(message)
      setNotification(true)
      setTimeout(() => {
        setNotification(false)
      }, 3000)  
    }

    return (
      <td>
        {userLoginId === allocatedToId && dataItem && dataItem.inEdit ? (
          <DropDownList
            style={{ width: "100%" }}
            data={CONSTANTS.csrpositionStatuswithId}
            onChange={handleChange}
            dataItemKey='id'
            textField="name"
          />
        ) : (dataValue)}
      </td>
    )
  }

  const getTableValues = () => {
    props.getTables()
  }

  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const redirection = (candidateLoginId: string) => {
    localStorage.setItem('ResourcesCandidateLoginId', candidateLoginId);
    localStorage.setItem('ResourcesTab', '6');
    openInNewTab(`${window.location.origin}/createResources`)
  }

  const onSubmit = (data: any) => {
    setSubmitResources(false)
    props.submitPostCandidateToJob(data)
  }

  return (
    <div className='tableStyle no-top-padd no-min-height tableMaxHeight'>
      <Grid
        data={orderBy(props.state.items, sort, '')}
        onPageChange={props.pageChange}
        //   total={props.total}
        //   skip={props.state.skip}
        //   pageable={props.state.pageable}
        //   pageSize={props.state.pageSize}
        //   onItemChange={props.itemChange}
        onRowClick={(e) => rowClick(e)}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
        }}
      >
        <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
        <Column field="name" title="Name" className="pointer" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string) => redirection(candidateLoginId))} />
        <Column field="Skills" title="Skills" cell={skillsCell} />
        <Column field="experience" title="Experience" cell={experienceCell} />
        <Column field="candidateStatus" title="ellow Status" />
        <Column field="availabilityValue" title="Availability" cell={availablityCell} />
        <Column field="resourceCost" title="Resource Cost" cell={resourcecostCell} />
        <Column field="positionEllowRate" title="ellow Rate" cell={ellowrateCell} />
        <Column field="positionStatus" title="Position Status" cell={(props: GridCellProps) => positionStatusDropdown(props, () => getTableValues())} />
        <Column cell={viewButton} />
      </Grid>
      {submitResources && <SubmitResources type='resources' defaultValues={submitResourcesData} jobId={jobId} ClickHandler={onSubmit} onClose={() => setSubmitResources(false)} crRecruiter={true}/>}
      { fulltimeDetails && <FulltimeDetails onClose={() => setFulltimeDetails(false)} allocatedTo={allocatedTo} ClickHandler={submmitFUlltimeDetails} buttonName={'Save'}/>}
      {notification && <NotificationAlert onClose={() => setNotification(false)} closable={true} type={'error'} icon={icon} >{message}</NotificationAlert>}
    </div>
  )
}

export default CRAppliedResourcesTable;

const nameCell = (props: GridCellProps, redirection: any) => {
  const profileImage = props.dataItem.googleProfileImage ? props.dataItem.googleProfileImage : " "

  return (
    <td>
      <div className="userInfo 001" onClick={() => redirection(props.dataItem.loginId)}>
        {profileImage === " " ?
          <figure>{props.dataItem && props.dataItem.firstName && props.dataItem.firstName[0]}{props.dataItem && props.dataItem.lastName && props.dataItem.lastName[0]}</figure>
          :
          <figure><img src={profileImage}></img></figure>}
        {props.dataItem.name}
      </div>
    </td>
  )
}
